<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Repertory/index.html')">库存管理</div></el-breadcrumb-item>
			<el-breadcrumb-item>商品库存</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="商品名称">
				<el-input v-model="item.name" placeholder="请输入商品名称" size="small"></el-input>
			</el-form-item>
			<el-form-item label="库存来源">
				<el-cascader v-model="item.supplier_id" :options="options" :show-all-levels="false" size="small" clearable
					:props="{label: 'name',value:'id',checkStrictly: true}"></el-cascader>
			</el-form-item>
			<el-form-item label="商品分类">
				<el-cascader v-model="item.product_category_id" placeholder="请选择"
					:options="optionsProduct" size="small" :props="filterProps" clearable></el-cascader>
			</el-form-item>

			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
				<el-button type="primary" @click="excelOut" size="medium">批量导出</el-button>
			</el-form-item>
		</el-form>
		<!--		数据是list 通过list展示-->
		<el-table :data="list" border>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>

			<el-table-column label="商品图片">
				<!--				商品的组件和插槽-->
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;">
						<img :src="scope.row.product_pic_main" height="30" style="display: flex; margin-right: 5px;" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="name" label="商品名称"></el-table-column>
			<el-table-column prop="stock_total" label="当前库存"></el-table-column>
			<el-table-column prop="productcategory" label="商品分类">
				<template slot-scope="scope" v-if="scope.row.productcategory">
					{{scope.row.productcategory.name}}
				</template>
			</el-table-column>
			<el-table-column label="库存来源">
				<template slot-scope="scope">
					<div v-if="scope.row.supplier_id > 0">
						<el-tag type="warning" size="medium">供</el-tag>{{scope.row.supplier ? scope.row.supplier.name : ''}}
					</div>
					<div v-if="scope.row.store_id > 0">
						<el-tag type="danger" size="medium">店</el-tag>{{scope.row.store ? scope.row.store.name : ''}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="created_date" label="创建日期"></el-table-column>
			<el-table-column label="操作" width="160">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="edit(scope.row.id)">查看明细</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :current-page.sync="pageNum"
			:page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [],
				isLoad: false,
				pageNum: 0,
				pageSize: 20,
				total: 0,
				page: 1,
				// 查询
				item: {},
				optionsProduct: [],
				options: [{
					id: 0,
					name: '供应商',
					children: []
				}, {
					id: 1,
					name: '店铺',
					children: []
				}],
				filterProps: {
					value: 'id',
					label: 'name',
					emitPath: false,
					checkStrictly: true
				},
			}
		},
		created() {
			this.item = {
					page: this.page,
					limit: this.pageSize
				},
				this.getData()
			this.loadList()
		},
		methods: {
			gotopage(url){
			     var link =  this.$router.resolve({
			     path: url
			   });
			   window.open(link.href, '_blank')
			},
			async getData() {
				// 获取商品分类
				let res = ''
				res = await this.axios.get('/admin/data/getCategoryTreeAdmin', {})
				this.optionsProduct = res.data.list

				res = await this.axios.post('/admin/supplier/list', {
				})
				this.$set(this.options[0], 'children', res.data.list)

				res = await this.axios.post('/admin/business.store/list', {
				})
				this.$set(this.options[1], 'children', res.data.list)
			},
			loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				// 库存商品列表
				this.axios.post('/admin/stock/listStock', this.item)
					.then(res => {
						this.isLoad = !this.isLoad
						// 获取数据
						this.list = res.data.list.data
						// 页数 page
						this.total = res.data.list.total
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				this.$router.push({
					path: '/Repertory/detail.html',
					query: {
						id: id
					}
				});
			},
			sizeReload(val) {
				this.item.page = val
				this.loadList()
			},
			pageReload(val) {
				this.item.page = val
				this.loadList()
			},
			// 搜索查询
			submit() {
				if (this.item.supplier_id) {
					this.item.type = this.item.supplier_id[0]
					if (this.item.supplier_id.length > 0) {
						this.item.supplier_id = this.item.supplier_id[1]
					}else{
						this.item.supplier_id = ''
					}
				}
				this.pageNum = 1
				this.item.page = 1
				this.loadList()
			},
			// 导出
			excelOut() {
				if (this.isLoad) {
					return false
				}

				this.isLoad = !this.isLoad
				setTimeout(function () {
					this.isLoad = false
				}.bind(this), 100000);
				this.axios.post('/admin/stock/listStockExport', this.item)
						.then(res => {
							this.isLoad = false
							if (res.code == 1) {
								import('@/vendor/Export2Excel.js').then(excel => {
									var expCellName = res.data.expCellName
									var tHeader = []
									var filterVal = []
									for (var i in expCellName) {
										tHeader.push(expCellName[i])
										filterVal.push(i)
									}
									const expTableData = res.data.expTableData
									const data = this.formatJson(filterVal, expTableData)
									var d = new Date()
									var year = d.getFullYear()
									var month = d.getMonth()
									var date = d.getDate()
									var hour = d.getHours()
									var minute = d.getMinutes()
									var second = d.getSeconds()
									month = month < 10 ? '0' + month : month
									date = date < 10 ? '0' + date : date
									hour = hour < 10 ? '0' + hour : hour
									minute = minute < 10 ? '0' + minute : minute
									second = second < 10 ? '0' + second : second
									excel.export_json_to_excel({
										header: tHeader,
										data,
										filename: '商品库存_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
										autoWidth: this.autoWidth,
										bookType: this.bookType
									})
								})
							} else {
								this.$message({
									message: res.msg,
									type: 'error',
									duration: 3 * 1000
								})
							}
						})
			},
			formatJson (filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => {
					return v[j]
				}))
			},
		}
	}
</script>
<style scoped>
</style>
